import { Controller } from 'stimulus';
import { useEventListener, Fullscreen } from '@/js/util';

const ACTIVE_CLASS = 'is-active';
const STOP_OVERFLOW_CLASS = 'overflow-hidden';

export default class extends Controller {
  initialize() {
    this.handleFullscreenChange = this.handleFullscreenChange.bind(this);
  }

  connect() {
    useEventListener(this);
    this.eventRemovals = [];
  }

  disconnect() {
    this.close();
  }

  open() {
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  handleFullscreenChange(_e) {
    this.visible = Fullscreen.enabled;
  }

  get visible() {
    return this.element.classList.contains(ACTIVE_CLASS);
  }

  set visible(value) {
    if (this.visible === value) {
      return;
    }

    document.body.classList.toggle(STOP_OVERFLOW_CLASS, value);
    this.element.classList.toggle(ACTIVE_CLASS, value);

    if (value) {
      Fullscreen.enter(this.element).catch(console.warn);
      this.#setupEvents();
      this.dispatch('open');
    } else {
      this.#cleanEvents();
      Fullscreen.enabled && Fullscreen.exit().catch(console.warn);
      this.dispatch('close');
    }
  }

  #setupEvents() {
    this.eventRemovals.push(
      this.addEventListener(document, 'fullscreenchange', this.handleFullscreenChange),
      this.addEventListener(document, 'webkitfullscreenchange', this.handleFullscreenChange)
    );
  }

  #cleanEvents() {
    while (this.eventRemovals.length) {
      this.eventRemovals.shift().call();
    }
  }
}
